<template>
	<div class="auth register">
		<h1>{{ $t('base.auth.signup') }}</h1>
		<form @submit.prevent="validateAndSubmit" class="form-auth">
			<input-text autocomplete="name" v-model="model.fullname" name="login_fullname" :placeholder="$t('labels.auth.fullname')" rules="required|alpha_spaces"/>
			<input-text autocomplete="email" v-model="model.email" name="login_email" :placeholder="$t('labels.auth.email')" rules="required|email"/>
			<input-password v-model="model.password" autocomplete="new-password" name="password" :placeholder="$t('labels.auth.password')" rules="required|min:8"/>
			<input-password v-model="model.confirm_password" autocomplete="new-password" name="confirm_password" :placeholder="$t('labels.auth.confirm_password')" :rules="'required|confirmed:'+model.password"/>
			<error-box v-if="form_error" :error="form_error"/>
			<input-checkbox name="terms-and-use" v-model="model.terms" rules="authorize" :placeholder="$t('labels.general.use_policy')">
				{{ $t('base.auth.msg_use_policy') }} <router-link :to="{ name: 'AuthStaticContentUsePolicy' }">{{ $t('labels.general.use_policy') }}</router-link>.
			</input-checkbox>
			<input-checkbox name="privacy-policy" v-model="model.privacy" rules="authorize" :placeholder="$t('labels.general.privacy_policy')">
				{{ $t('base.auth.msg_privacy_policy') }} <router-link :to="{ name: 'AuthStaticContentPrivacyPolicy' }">{{ $t('labels.general.privacy_policy') }}</router-link>.
			</input-checkbox>
			<div class="form-group form-group--inline">
				<router-link class="btn btn-round" :to="{ name: 'AuthLogin' }">{{ $t('base.auth.back') }}</router-link>
				<button type="submit" class="btn btn-round btn-primary">{{ $t('buttons.auth.create_account') }}</button>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	data () {
		return {
			model: {
				fullname: '',
				email: '',
				password: '',
				confirm_password: '',
				terms: false,
				privacy: false,
			},
			form_error: null
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			const credentials = {
				fullname: this.model.fullname,
				email: this.model.email,
				password: this.model.password
			}
			this.$api.auth.register(this, credentials).then(response => {
				this.$log.info('user register', 'auth.register OK', response)()
				this.$router.push({ name: 'AuthLogin' })
			}).catch(errors => {
				this.$log.error('user register', 'auth.register ERROR', errors)()
				this.form_error = errors
			})
		}
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.signup'))
	}
}
</script>


<style scoped>

	.auth.register > h1 {
		color: #000;
		border-bottom: 1px solid black;
	}

</style>



// WEBPACK FOOTER //
// src/components/auth/AuthRegister.vue